/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {Modal, Button, Input, Popover, OverlayTrigger, Row, Col} from 'react-bootstrap';
import DraggableModalDialog from './../DraggableModal';
import { connect } from 'react-redux';


var RandomCapsDialog = React.createClass({
    getInitialState() {
        return {
            strLowCap: "10",
            strUpCap: "100"
        }
    },

    lowCapChange(e) {
        this.setState(Object.assign({}, this.state, {
            strLowCap: e.target.value
        }));
    },

    lowCapStatus() {
        if (isNaN(parseFloat(this.state.strLowCap))) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    upCapChange(e) {
        this.setState(Object.assign({}, this.state, {
            strUpCap: e.target.value
        }));
    },

    upCapStatus() {
        if (isNaN(parseFloat(this.state.strUpCap))) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    badRange() {
        return isNaN(parseFloat(this.state.strLowCap)) || isNaN(parseFloat(this.state.strUpCap));
    },

    applyHandler() {
        if (this.badRange()) {
            return;
        }
        let links = this.props.net.links;
        let newLinks = [];
        let lowCap = parseFloat(this.state.strLowCap);
        let upCap = parseFloat(this.state.strUpCap);
        for (let link of links) {
            let newLink = Object.assign({}, link);
            newLink.capacity = lowCap + Math.random()*(upCap - lowCap);
            newLinks.push(newLink);
        }
        let newNet = Object.assign({}, this.props.net, {links: newLinks});
        this.props.updateCapacities(newNet);
    },

    helpPopover(){
        return (<Popover id="RandomCapsHelpPopover" title="Randomize Capacities Help">
            <p>This command allows you to assign random capacities to all links in the network.</p>
        </Popover>)
    },

    render(){

        return(
        <Modal show={this.props.open} onHide={this.props.close} dialogClassName="rand-cap-modal"
               dialogComponentClass={DraggableModalDialog}
           enforceFocus={false} backdrop={false} >
            <Modal.Header closeButton>
                <Modal.Title>Randomize Link Capacities</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: 0}}>
                <form className="form-horizontal">
                    <Row>
                        <Col  xsOffset={1}><p><em>Parameters</em></p></Col>
                    </Row>
                    <Row>
                        <div className={this.lowCapStatus()}>
                        <Col xs={6} xsOffset={1}><label className="control-label">Lower Capacity Bound</label></Col>
                        <Col xs={3}><input type="text" value={this.state.strLowCap}
                                           onChange={this.lowCapChange} className="form-control"/></Col>
                            </div>
                    </Row>
                    <Row><p></p></Row>
                    <Row>
                        <div className={this.upCapStatus()}>
                        <Col xs={6} xsOffset={1}><label className="control-label">Upper Capacity Bound</label></Col>
                        <Col xs={3}><input type="text" value={this.state.strUpCap}
                                           onChange={this.upCapChange} className="form-control"/></Col>
                            </div>
                    </Row>
                    </form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary"
                            onClick={this.applyHandler} disabled={this.badRange()}>Apply </Button>
                <Button onClick={this.props.close} >Close</Button>
                <OverlayTrigger trigger="click" placement="top" overlay={this.helpPopover()}>
                    <Button bsStyle={'info'}>Help</Button>
                </OverlayTrigger>
            </Modal.Footer>
            </Modal> 
    )}
});

const mapStateToProps = (state) => {
    return {
        open: state.uiState.showRandomCapsModal,
        net: state.net
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_RAND_CAP_DIALOG'});
        },
        updateCapacities: (net) => {
            dispatch({type: 'UPDATE_LINK_CAPACITIES', net: net});
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RandomCapsDialog)




// WEBPACK FOOTER //
// ./src/netManip/RandomCapsDialog.js